import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style/FAQ.css';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();

  const faqData = t('faqpricing.questions', { returnObjects: true });

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2>{t('faqpricing.title')}</h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div className="faq-item" key={index}>
            <div className="faq-question" onClick={() => toggleAnswer(index)}>
              <span>{item.question}</span>
              <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
            </div>
            <div className={`faq-answer-container ${activeIndex === index ? 'open' : ''}`}>
              <div className="faq-answer-inner" style={{ whiteSpace: 'pre-line' }}>{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
